<template>
    <div class="electricity">
        <Title chineseTitle="用电量统计" englishTitle="Electricity consumption statistics">
        </Title>
        <div class="electricityContent">
            <Chart @onchange="onchange" :data="powerData" />
        </div>
    </div>
</template>

<script>
    import Title from "@/components/Title.vue";
    import Chart from "@/components/Chart";
    import {
        GetCompare,
    } from "@/components/Request";

    export default {
        name: "ElectricChart",
        components: {
            Title,
            Chart,
        },
        props: ["paramType", "areaId"],
        data() {
            return {
                powerData: [],
            };
        },
        mounted() {

        },
        methods: {
            onchange(e) {
                let params = {
                    compareType: "ALTERNATE",
                    dateRange: "YEAR",
                    paramType: this.paramType,
                    value: this.paramType == "PROJECT_ID" ? this.$store.state.projectId : this.areaId,
                };

                if (e.type === "环比") {
                    if (e.range === "日") {
                        params.dateRange = "DAY";
                    } else if (e.range === "月") {
                        params.dateRange = "MONTH";
                    }
                } else {
                    params.compareType = "SEPARATED";
                    params.dateRange = "YEAR";
                }

                GetCompare(params).then(({
                    data
                }) => {
                    this.$set(this, "powerData", [data.data.result[0].toFixed(0),data.data.result[1].toFixed(0)]);
                });
            }
        }
    };
</script>

<style lang="less" scoped>
    .electricity {
        position: fixed;
        top: 6320/108vh;
        left: 160/192vw;
    }

    .electricityContent {
        width: 4000/192vw;
        height: 3400/108vh;
        background-color: rgba(3, 13, 24, 0.75);
        margin-left: 1vw;
        overflow: hidden;
    }
</style>